<template>
  <div class="item" id="pg-finish">
    <div class="left" data-toggle="collapse" data-target="#item-finish" aria-expanded="true" aria-controls="item-finish">
      <p class="text-add-course">Finalização</p>
    </div>
    <div id="item-finish" class="text-center rigth collapse width"  aria-labelledby="pg-finish" data-parent="#pg-add-course">
      <h3><b>Tudo certo até aqui!</b></h3>
      <h6>Revise as informações e você já pode salvar o seu curso.</h6>
      <p>Ok, logo após salvar o curso, você sera redirecionado para a página geral de informações do curso.</p>
      <p>Lá você poderá criar a grade do curso entre outras informações</p>

      <button
        class="btn btn-secondary px-3 mr-2"
        data-toggle="collapse"
        data-target="#item-info"
        aria-expanded="true"
        aria-controls="item-info"
      >Revisar Conteudo</button>
      <button class="btn btn-primary px-3" @click="registerCourse">Salvar Curso!!</button>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapGetters, mapActions } from 'vuex';
import Axios from 'axios'

export default {
  name: 'add-course-finishing',
  computed: {
    ...mapGetters({
      newCourse: 'getNewCourse',
      user: 'getCurrentUser'
    })
  },
  methods: {
    ...mapActions({
      cleanCourse: "cleanCourse"
    }),

    registerCourse: function () {
      Swal.fire({
        title: 'Gravando Curso!',
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })

      Axios.post(`/teacher/new/course`, {
        user: this.user,
        course: this.newCourse
      })
      .then( res => {
        Swal.fire({
          icon: 'success',
          title: 'Tudo certo!',
          text: 'Seu curso foi gravado com sucesso'
        })
        this.cleanCourse()
        let name = res.data.name.split(" ").join("-").toLowerCase()
        this.$router.push(`/curso/${ res.data.id }/${ name }`)
      })
      .catch( err => {
        Swal.fire({
          icon: 'error',
          title: 'Opss! Alguma coisa deu errado',
          text: err.message
        })
        console.error( err )
      })
    }
  }
}
</script>
